import { Component, OnInit } from '@angular/core';


export interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}

export const ROUTES: RouteInfo[] = [
    { path: '/dashboard',     title: 'Dashboard',         icon:'nc-bank',       class: '' },
    { path: '/query',         title: 'Query',             icon:'nc-zoom-split',    class: '' },
    /*{ path: '/maps',          title: 'Maps',              icon:'nc-pin-3',      class: '' },*/
    { path: '/table',         title: 'Table List',        icon:'nc-tile-56',    class: '' },
    { path: '/upload',         title: 'Upload CSV',        icon:'nc-cloud-upload-94',    class: '' },
    { path: '/history',    title: 'History',        icon:'nc-favourite-28', class: '' }
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls:['sidebar.component.scss']
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    constructor(){}
        ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
    }
}
